//import moment from 'moment'

//let customDateFormatter = (value) => { return moment(value).format('DD/MM/YYYY') }

let searchInputs = [
    {
        id: 'insuranceLine',
        label: 'Insurance Line',
        type: 'select',
        options: []
    },
    {
        id: 'reseller',
        label: 'Reseller',
        type: 'select',
        options: [
        ]
    },
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference'
    },
    {
        id: 'documentType',
        label: 'Document Type',
        type: 'select',
        options: [
            {
                id: 1008,
                label: 'Repair paperwork'
            }
        ]
    }
]

export { searchInputs }